export default "__VITE_ASSET__ejb2PkE8__"